import { render, staticRenderFns } from "./Einstellungen.vue?vue&type=template&id=2fbcad26&scoped=true"
import script from "./Einstellungen.vue?vue&type=script&lang=js"
export * from "./Einstellungen.vue?vue&type=script&lang=js"
import style0 from "./Einstellungen.vue?vue&type=style&index=0&id=2fbcad26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbcad26",
  null
  
)

export default component.exports